/** This function handles authentication,
 *  if auth is passed as false then it redirects to production 
 *  login url: (https://acuvisor.com/training/login')
 *  @param isAuth is a boolean type , takes true if auth is present and false if auth isn't
 * 
 *  For now the checking of auth isn't present in session/cookies/localstorage in this function
 *  It only redirects to the login page, isAuth must be checked before passing true or false ...
 * **/    
export const  handleAuth = (isAuth) =>{
    console.log("Auth handler Called !",isAuth)
    if(isAuth) return true;

    console.log("Redirecting to the sign in page")
    window.location.replace('https://acuvisor.com/training/login')
}